import React from "react";

export default function ForgotPasswordConfirm({
  username,
  resetCode,
  setResetCode,
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  Api,
  onStateChange,
}) {
  const passwordsMatch = newPassword === confirmPassword;
  const canSubmit =
    resetCode.trim() !== "" &&
    newPassword.trim() !== "" &&
    confirmPassword.trim() !== "" &&
    passwordsMatch;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwordsMatch) {
      alert("Passwords do not match");
      return;
    }

    try {
      await Api.confirmForgotPassword(username, resetCode, newPassword);
      alert("Password successfully reset");
      onStateChange("login");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "300px",
        padding: "40px",
        backgroundColor: "#111d30",
        borderRadius: "12px",
        border: "1px solid #22416b",
        boxShadow: "0px 16px 36px rgba(10, 22, 42, 0.45)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#e7edf7" }}>
        Enter Verification Code
      </h2>

      <input
        type="text"
        value={resetCode}
        onChange={(e) => setResetCode(e.target.value)}
        placeholder="Verification Code"
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "20px",
          backgroundColor: "#0f1e33",
          color: "#e7edf7",
          border: "1px solid #22416b",
          borderRadius: "8px",
        }}
      />

      <input
        type={showPassword ? "text" : "password"}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="New Password"
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
          backgroundColor: "#0f1e33",
          color: "#e7edf7",
          border: `1px solid ${confirmPassword && !passwordsMatch ? "red" : "#22416b"}`,
          borderRadius: "8px",
        }}
      />

      <input
        type={showPassword ? "text" : "password"}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="Confirm Password"
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "5px",
          backgroundColor: "#0f1e33",
          color: "#e7edf7",
          border: `1px solid ${confirmPassword && !passwordsMatch ? "red" : "#22416b"}`,
          borderRadius: "8px",
        }}
      />

      {/* Warning message */}
      {!passwordsMatch && confirmPassword.length > 0 && (
        <p style={{ color: "red", fontSize: "12px", marginBottom: "10px" }}>
          Passwords do not match
        </p>
      )}

      <button
        type="submit"
        disabled={!canSubmit}
        style={{
          width: "100%",
          padding: "10px",
          background: canSubmit
            ? "linear-gradient(135deg, #1f6feb 0%, #0f355e 100%)"
            : "#1d2f4d",
          color: "#e7edf7",
          border: "1px solid #2c4f83",
          borderRadius: "10px",
          cursor: canSubmit ? "pointer" : "not-allowed",
          marginTop: "10px",
          boxShadow: canSubmit ? "0 10px 24px rgba(15, 53, 94, 0.45)" : "none",
        }}
      >
        Reset Password
      </button>
    </form>
  );
}
